import apiServices from "utils/axios";

export const register = async (payload) => {
  const { data } = await apiServices.post('/auth/register', payload);
  return data;
};

export const login = async (payload) => {
  const { data } = await apiServices.post('/auth/login', payload);
  return data;
};


export const loginMicrosoft = async () => {
  const { data } = await apiServices.get('/auth/microsoft/url');
  return data;
};
